"use client"

import { ProductCard } from "@/components/organisms"
import { ProductsPagination } from "@/components/organisms"
import { isBarebonesTheme } from "@/lib/theme/storefront-theme"
import { useStorefrontTheme } from "@/lib/theme/storefront-theme-context"
import { HttpTypes } from "@medusajs/types"

export const ProductGrid = ({
  products,
  hits,
  count,
  locale,
  pageSize = 36,
  gridClassName = "grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5",
}: {
  products: HttpTypes.StoreProduct[]
  hits: HttpTypes.StoreProduct[]
  count: number
  locale: string
  pageSize?: number
  gridClassName?: string
}) => {
  const pages = Math.ceil((count || 0) / pageSize) || 0
  const theme = useStorefrontTheme()
  const columns = isBarebonesTheme(theme)
    ? "grid-cols-2 lg:grid-cols-4 gap-8"
    : `${gridClassName} gap-[30px]`

  return (
    <div className="w-full">
      <ul className={`grid ${columns}`}>
        {hits.map((hit) => (
          <ProductCard
            api_product={products.find((p) => p.id === hit.id)}
            key={hit.id}
            product={hit}
            locale={locale}
          />
        ))}
      </ul>
      <ProductsPagination pages={pages} />
    </div>
  )
}
